import { Routes, Route, Navigate } from 'react-router-dom';
import EmployeeLayout from '../components/employee/EmployeeLayout.jsx';
import ApprovalQueuePage from './approver/ApprovalQueuePage.jsx';
import ReviewRequestPage from './approver/ReviewRequestPage.jsx';

export default function ApproverPage() {
  return (
    <Routes>
      <Route element={<EmployeeLayout />}>
        <Route index element={<ApprovalQueuePage />} />
        <Route path=":userId/:requestId" element={<ReviewRequestPage />} />
        <Route path="*" element={<Navigate to="/approvals" replace />} />
      </Route>
    </Routes>
  );
}
